import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-trust-api-key-update-modal',
  templateUrl: './trust-api-key-update-modal.component.pug',
  styleUrls: ['./trust-api-key-update-modal.component.scss'],
  standalone: false
})
export class TrustApiKeyUpdateModalComponent {
  @Input() apiKey = '';
  @Input() keyExist = false;
  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() cancelClick: EventEmitter<any> = new EventEmitter();
  @Output() saveClick: EventEmitter<any> = new EventEmitter();
  acceptedAgreement = false;
  isChanged = false;
  btnGenerate = $localize `Generate`;
  url = environment.TRUST_MARKETPLACE_URL;
  constructor(
    public bsModalRef: BsModalRef,
  ) { }
  delete(){
    this.deleteClick.emit(this.apiKey);
    this.bsModalRef.hide();
  }
  save(){
    this.saveClick.emit({'xrefApiKey':this.apiKey});
    this.bsModalRef.hide();
  }
  cancel(){
    this.cancelClick.emit(this.apiKey);
    this.bsModalRef.hide();
  }
  goToTrustConsole(){
    window.open(this.url);
  }
}
